import { Clock } from 'lucide-react';
import SeriesCard from './SeriesCard';

const roundLabels: Record<string, string> = {
  'round1': 'סיבוב ראשון',
  'first_round': 'סיבוב ראשון',
  'west_semis': 'חצי גמר מערבי',
  'east_semis': 'חצי גמר מזרחי',
  'conf_semis': 'חצי גמר הקונפרנס',
  'west_finals': 'גמר מערבי',
  'east_finals': 'גמר מזרחי',
  'conf_finals': 'גמר הקונפרנס',
  'finals': 'הגמר הגדול',
  'champion': 'ניחוש האלוף',
};

const roundOrder = ['round1', 'first_round', 'west_semis', 'east_semis', 'conf_semis', 'west_finals', 'east_finals', 'conf_finals', 'finals', 'champion'];

const statusPriority: Record<string, number> = { upcoming: 0, in_progress: 1, completed: 2 };

interface SeriesListProps {
  seriesList: any[];
  groupId: string;
  userBets: any[];
  onRevealClick?: (seriesId: string) => void;
}

const SeriesList = ({ seriesList, groupId, userBets, onRevealClick }: SeriesListProps) => {
  if (seriesList.length === 0) {
    return (
      <div className="text-center py-20">
        <Clock className="w-12 h-12 text-muted-foreground mx-auto mb-4 opacity-40" />
        <p className="text-muted-foreground font-medium">הפלייאוף עוד לא התחיל 🏀</p>
        <p className="text-xs text-muted-foreground mt-1">כשיפורסמו סדרות — הן יופיעו כאן</p>
      </div>
    );
  }

  const grouped: Record<string, any[]> = {};
  seriesList.forEach(s => {
    const round = s.round || 'round1';
    if (!grouped[round]) grouped[round] = [];
    grouped[round].push(s);
  });

  // Within each round, status=upcoming first, then in_progress, then completed
  Object.keys(grouped).forEach(round => {
    grouped[round].sort((a, b) => (statusPriority[a.status] ?? 99) - (statusPriority[b.status] ?? 99));
  });

  // Rounds containing any upcoming series outrank rounds with only in_progress/completed,
  // so the next bettable round surfaces above older rounds still wrapping up.
  const hasUpcoming = (round: string) =>
    grouped[round].some(s => s.status === 'upcoming');
  const sortedRounds = Object.keys(grouped).sort((a, b) => {
    const ua = hasUpcoming(a) ? 0 : 1;
    const ub = hasUpcoming(b) ? 0 : 1;
    if (ua !== ub) return ua - ub;
    const ai = roundOrder.indexOf(a);
    const bi = roundOrder.indexOf(b);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });

  let globalIndex = 0;

  return (
    <div className="space-y-6">
      {sortedRounds.map(round => (
        <div key={round}>
          <p className="section-label mb-3">{roundLabels[round] || round}</p>
          {grouped[round].map(s => {
            const bet = userBets.find(b => b.series_id === s.id);
            const idx = globalIndex++;
            return (
              <SeriesCard key={s.id} series={s} groupId={groupId} userBet={bet} index={idx} onRevealClick={onRevealClick} />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default SeriesList;
